/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Enable_Disable_ListInputs */



/**
* | output |
* | --- |
* | "Enable/Disable {name}" |
*
* @param {Enable_Disable_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_disable_list = /** @type {((inputs: Enable_Disable_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Disable_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Activer/Désactiver ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} aktivieren/deaktivieren`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Abilita/Disabilita ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Включить/Выключить ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Habilitar/Deshabilitar ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`启用/禁用 ${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を有効/無効にする`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} को सक्षम/अक्षम करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ativar/Desativar ${i?.name}`)
	return /** @type {LocalizedString} */ (`Enable/Disable ${i?.name}`)
});